import React from 'react'
import styled, { css } from 'styled-components'
import { MaskedInput as Masked } from 'ui-kit-sber'
import { withTypographyParagraph } from '@components/Typography'
import { IMaskedInput as IMaskedInputAnt } from 'ui-kit-sber/dist/js/components/MaskedInput'

export const withInput = css`
  width: 100%;
  padding: 15px;
  border: 1px solid ${({ theme }) => theme.colors.middleGray};
  border-radius: ${({ theme }) => theme.general.borderRadius};
  outline: none;

  &::placeholder {
    color: 1px solid ${({ theme }) => theme.colors.middleGray};
  }

  &:disabled {
    background: ${({ theme }) => theme.colors.lightGray};
    color: ${({ theme }) => theme.colors.middleGray};
    border-color: ${({ theme }) => theme.colors.middleGray};
  }
  ${withTypographyParagraph}
  font-size: 16px;
  line-height: 24px;
`

const Input = styled.input`
  ${withInput}
`

export interface IMaskedInput extends Omit<IMaskedInputAnt, 'mask'> {
  mask: string
}

const SMaskedInput = styled(Masked)``
export const MaskedInput: React.FC<IMaskedInput> = ({ mask, ...rest }) => <SMaskedInput mask={mask} {...rest} />

MaskedInput.displayName = 'MaskedInput'

export default Input
